import type { GroupColor } from '@kaba/shared';

/** Punktfarbe je Gruppe – nur zur Orientierung, nie alleiniger Bedeutungsträger */
export const GROUP_DOT: Record<GroupColor, string> = {
  gray: 'bg-slate-400',
  blue: 'bg-sky-500',
  green: 'bg-emerald-500',
  yellow: 'bg-amber-400',
  orange: 'bg-orange-500',
  red: 'bg-rose-500',
  purple: 'bg-violet-500',
  pink: 'bg-pink-500',
};
